import type { InsuranceProduct, InsuranceProductVersion } from '../../model/model.ts'

import type { FrMrpaxePolicyItem, FrMrpaxePolicyItemsState } from './fr-mrpaxe-insurance.ts'
import type { FrMrpaxePricingVersion } from './fr-mrpaxe-pricing-versions.ts'
import type {
  FrMrpaxeActivitiesConfigVersionFormat,
  FrMrpaxeBaseName,
  FrMrpaxeProductVersionFormat,
  FrMrpaxeProductVersionPrefix,
  FrMrpaxeStaticFileIdFormat,
} from './model.ts'
import { frMrpaxePolicyItems_v1_0_0 } from './v1_0_0/policy-items.ts'
import { frMrpaxeStaticFilesIds_v1_0_0 } from './v1_0_0/static-files.ts'

export const frMrpaxeProductName = 'product-fr-mrp-axeria'
export type FrMrpaxeProductName = typeof frMrpaxeProductName

export const frMrpaxeProductVersions = [
  /**
   * Initial version, carried by Axeria.
   */
  'product-fr-mrp-axeria-1.0.0-2026-10-03',
] as const satisfies FrMrpaxeProductVersionFormat[]

export type FrMrpaxeProductVersion = (typeof frMrpaxeProductVersions)[number]

type FrMrpaxeInsuranceProductVersion = InsuranceProductVersion<
  FrMrpaxeProductVersionPrefix,
  FrMrpaxeBaseName,
  FrMrpaxeProductVersion,
  FrMrpaxePolicyItem,
  FrMrpaxeStaticFileIdFormat,
  FrMrpaxePricingVersion,
  FrMrpaxeActivitiesConfigVersionFormat,
  FrMrpaxePolicyItemsState
>

type FrMrpaxeInsuranceProduct = InsuranceProduct<
  FrMrpaxeProductVersionPrefix,
  FrMrpaxeBaseName,
  FrMrpaxeProductVersion,
  FrMrpaxePolicyItem,
  FrMrpaxeStaticFileIdFormat,
  FrMrpaxePricingVersion,
  FrMrpaxeActivitiesConfigVersionFormat,
  FrMrpaxePolicyItemsState
>

export const frMrpaxeProduct_v1_0_0 = {
  version: 'product-fr-mrp-axeria-1.0.0-2026-10-03',
  description: 'Initial version of FR-MRPAXE product',
  policyItems: frMrpaxePolicyItems_v1_0_0,
  staticFilesId: [...frMrpaxeStaticFilesIds_v1_0_0],
  pricingVersion: ['pricing-fr-mrp-axeria-1.0.0-2026-10-03', 'pricing-fr-mrp-axeria-1.0.1-2027-01-01'],
  activitiesConfigVersion: 'activities-config-fr-mrp-axeria-1.0.0-2026-10-03',
} as const satisfies FrMrpaxeInsuranceProductVersion

export const frMrpaxeProduct = {
  id: 'fr-mrpaxe',
  versions: {
    'product-fr-mrp-axeria-1.0.0-2026-10-03': frMrpaxeProduct_v1_0_0,
  },
} as const satisfies FrMrpaxeInsuranceProduct
export type FrMrpaxeProduct = typeof frMrpaxeProduct
